/*
*
* Skapa LoadingIndicator
*
*/

import React from 'react';
import { LoadingBall } from "@ingka/loading";
import '@ingka/loading/dist/style.css'; //SKAPA needs it´s own css

export default function Spinner() {
	return (
		<LoadingBall />
	);
}
